import { Component, OnInit, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BillPayService } from '../services/bill-pay.service';

const LEGACY_MARKER = 'legacy';

@Component({
  selector: 'app-bookmark-banner',
  standalone: true,
  template: `
    @if (link && !dismissed) {
      <div class="alert alert-info alert-dismissible bookmark-banner mb-4" role="alert">
        <button type="button" class="btn-close" aria-label="Dismiss" (click)="dismissed = true"></button>
        <strong>Skip the sign in next time.</strong>
        <p class="mb-2">Bookmark this link and this page will open without signing in.</p>
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <input
            type="text"
            class="form-control form-control-sm font-monospace bookmark-link"
            [value]="link"
            readonly
            (focus)="$any($event.target).select()"
          />
          <button type="button" class="btn btn-sm btn-portal-accent text-nowrap" (click)="copy()">
            Copy Link
          </button>
          <span class="small text-success text-nowrap bookmark-copied" [class.visible]="copied">
            Copied!
          </span>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .bookmark-link {
        flex: 1 1 22rem;
        min-width: 0;
      }
      .bookmark-copied {
        opacity: 0;
        transition: opacity 0.25s ease-out;
      }
      .bookmark-copied.visible {
        opacity: 1;
      }
    `,
  ],
})
export class BookmarkBannerComponent implements OnInit {
  page = input.required<'integrated-reviews' | 'referral-request'>();

  private route = inject(ActivatedRoute);
  private billPayService = inject(BillPayService);

  link: string | null = null;
  dismissed = false;
  copied = false;

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('from') !== LEGACY_MARKER) {
      return;
    }

    this.billPayService.getPortalLink(this.page()).subscribe({
      next: response => (this.link = response.link),
    });
  }

  copy(): void {
    navigator.clipboard.writeText(this.link!);
    this.copied = true;
    setTimeout(() => (this.copied = false), 2500);
  }
}
